<template>
  <div class="search-page">
    <div class="search-item-box">
      <div class="flexStart">
        <div class="spaceLeft left-main">
          <div v-for="cfg in formConfigMin" :key="cfg.prop">
            <!-- tag选择 -->
            <div v-if="cfg.type=='tags'" class="search-item spaceLeft">
              <label class="search-item-lable" :class="{'search-item-lable-left':noAdvance}">{{cfg.label}}：</label>
              <template v-for="tag in cfg.option">
                <a-checkable-tag
                  :key="tag.value"
                  :checked="sourceSelf[cfg.prop]==tag.value"
                  @change="checked => tagChange(tag, checked ,cfg)"
                >
                  {{ tag.name }}
                </a-checkable-tag>
              </template>
            </div>
            <!-- 模式下拉选择 -->
            <div v-if="cfg.type=='selectSearch' && !cfg.hidden" class="search-item spaceLeft">
              <label class="search-item-lable" :class="{'search-item-lable-left':noAdvance}">{{cfg.label}}：</label>
              <div style="width:200px">
                <select-search
                  v-model="sourceSelf[cfg.prop]"
                  :mode="cfg.mode"
                  :searchSource="cfg.searchSource"
                  :dataSource="cfg.option"
                  :headNameFirst="cfg.headNameFirst"
                  :headNameSecond="cfg.headNameSecond"
                  :valuePorp="cfg.valuePorp"
                  :valuePorpReal="cfg.valuePorpReal"
                  :labelPorp="cfg.labelPorp"
                  :normal="cfg.normal"
                  @handleSearch="selectSearchSearch($event,cfg)"
                  @handleChange="selectSearchChange($event,cfg)"
                ></select-search>
              </div>
            </div>
            <!-- 普通选择 -->
            <div v-if="cfg.type=='select' && !cfg.hidden" class="search-item spaceLeft">
              <label class="search-item-lable" :class="{'search-item-lable-left':noAdvance}">{{cfg.label}}：</label>
              <div style="width:200px">
                <a-select
                  @change="selectChange($event,cfg)"
                  v-model="sourceSelf[cfg.prop]"
                  :allowClear="true"
                  option-label-prop="label"
                  :mode="cfg.mode"
                  style="width:100%"
                >
                  <a-select-option
                    v-for="item in cfg.option"
                    :key="item[cfg.defaultProps?cfg.defaultProps.value:'value']"
                    :value="item[cfg.defaultProps?cfg.defaultProps.value:'value']"
                    :label="item[cfg.defaultProps?cfg.defaultProps.label:'label']"
                    :title="item[cfg.defaultProps?cfg.defaultProps.label:'label']"
                  >{{item[cfg.defaultProps?cfg.defaultProps.label:'label']}}</a-select-option>
                </a-select>
              </div>
            </div>
            <!-- 日期 -->
            <div v-if="cfg.type=='dateRange' && !cfg.hidden" class="search-item spaceLeft">
              <label class="search-item-lable" :class="{'search-item-lable-left':noAdvance}">{{cfg.label}}：</label>
              <div style="width:200px">
                <a-range-picker
                  v-model="sourceSelf[cfg.prop]"
                  :placeholder="['开始时间','结束时间']"
                  valueFormat="YYYY-MM-DD"
                />
              </div>
            </div>
            <!-- 日期 -->
            <div v-if="cfg.type=='date'" class="search-item spaceLeft">
              <label class="search-item-lable" :class="{'search-item-lable-left':noAdvance}">{{cfg.label}}：</label>
              <div style="width:200px">
                <a-date-picker
                  valueFormat="YYYY-MM-DD"
                  v-model="sourceSelf[cfg.prop]"
                  placeholder="请选择"
                  style="width:200px"
                />
              </div>
            </div>
            <!-- 输入框 -->
            <div v-if="cfg.type=='input'" class="search-item spaceLeft">
              <label class="search-item-lable" :class="{'search-item-lable-left':noAdvance}">{{cfg.label}}：</label>
              <div style="width:200px">
                <a-input v-model="sourceSelf[cfg.prop]" placeholder="请输入" />
              </div>
            </div>
          </div>
        </div>
        <div class="spaceLeft">
          <a-button @click="search" class="search-btn-item" type="primary">查询</a-button>
          <a-button @click="clear" class="search-btn-item btn-blue-line">重置</a-button>
          <a
            @click="searchSwitch"
            class="search-btn-item  spaceLeft"
            v-if="!noAdvance"
          >高级查询<a-icon :type="advancedSearch?'up':'down'"></a-icon></a>
        </div>
      </div>
    </div>
    <div class="slot-box">
      <slot name="btns"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: [Object],
      required: false,
      default: function () {
        return {};
      },
    },
    formConfig: {
      type: [Array],
      required: true,
      default: function () {
        return [];
      },
    },
    noAdvance:{
      type: Boolean,
      required: false,
      default: function () {
        return false;
      }
    }
  },
  name: "search-form",
  data() {
    return {
      sourceSelf: this.utils.deepClone(this.source),
      advancedSearch: false,
    };
  },
  mounted() {},
  computed: {
    formConfigMin() {
      if(this.noAdvance){
        return this.formConfig;
      }
      if(this.advancedSearch){
        return this.formConfig;
      }else{
        return [this.formConfig[0]];
      }
    },
  },
  methods: {
    selectSearchSearch(value, cfg) {
      if (cfg.searchHandle) {
        this.$emit(cfg.searchHandle, value, this.sourceSelf, cfg);
      }
    },
    selectSearchChange(value, cfg) {
      if (cfg.changeHandle) {
        this.$emit(cfg.changeHandle, value, this.sourceSelf, cfg);
      }
    },
    selectChange(value, cfg) {
      if (cfg.changeHandle) {
        this.$emit(cfg.changeHandle, value, this.sourceSelf, cfg);
      }
    },
    tagChange(tag, checked ,cfg) {
      this.$set(this.sourceSelf,cfg.prop,(checked?tag.value:""));
      if(cfg.changeHandle){
        this.$emit(cfg.changeHandle, tag,checked, this.sourceSelf, cfg);
      }
      this.search();
    },
    searchSwitch() {
      for (let i in this.sourceSelf) {
        let val = this.sourceSelf[i];
        if (i == this.formConfig[0].prop) {
        } else if (Array.isArray(val)) {
          this.sourceSelf[i] = [];
        } else if (typeof val === "object") {
          this.sourceSelf[i] = {};
        } else {
          this.sourceSelf[i] = "";
        }
      }
      this.advancedSearch = !this.advancedSearch;
    },
    clear() {
      for (let i in this.sourceSelf) {
        let val = this.sourceSelf[i];
        if (Array.isArray(val)) {
          this.sourceSelf[i] = [];
        } else if (typeof val === "object") {
          this.sourceSelf[i] = {};
        } else {
          this.sourceSelf[i] = "";
        }
      }
      this.search();
    },
    search(el) {
      this.$emit("search", this.sourceSelf ,el);
    },
  },
  watch: {
    source: {
      handler(newVal, oldVal) {
        this.sourceSelf = this.utils.deepClone(this.source);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.search-page{
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.left-main{
  flex: 1;
}
.search-item-box{
  padding:16px 16px 3px 16px;
  border-radius: 2px;
  background: #fff;
  margin-bottom:13px;
}
.search-btn-item {
  margin: 0 10px 15px 0;
}
.bottom-box {
  border-top: 1px dashed #dfe2e6;
  padding-top: 20px;
}
.search-item-lable-left{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/search-form/search-form.vue